var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_1948_4355",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_1948_4355",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAAApgAAAKYB3X3/OAAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAF8SURBVEiJ7ZU9UgJBEEZfI4ElasxfCph4h8XTcAQ9gRFV3sJbuHsGDASMgZyiykRpg/0WVnZ1pWCN7KpJZrrfN90zPWPuTplWKZX+FwJVADO7Bm4AOxLXgSd3fzbgFrgH3jWOYVWNO4C5FF+AurtzyADqYrnYOPAALIAx0DgA3hBjIaYnhzwGAuASCM2ssW9NFBOKEYi5vUXuPtHCBRCZWXMPeBOIFBuIxRcBiUyBPnCuTApF5BMqpi/GxjJ9IIcAqCmT1g/wlnZe086nuz65jeburxI5UyYZEc2F8gkUk7HfdHKHOJN2Ct7WzjtFwbkCZtYR4I34TE6BkZkNzWwIjDTXl0+kmFxzYJC6y11gBkyBVqp5HoGlxiNqSqAl3xnQTXEGYm8FUvAJ0MxppApQyZlvKmYjkghsSmRmPZVlRXzd5plU3dfuvs6Zn6tcK5Wrl6wlAleCL4lvRAZeZIoJxIjEBEp+7Haf6499d/6NnaDn2ty93A/n/9Mvsk+vrE2Mi0OfCQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.93ac21a4c29994705f587ba53a9bcf5e.svg";
export { ForwardRef as ReactComponent };